document.addEventListener("DOMContentLoaded", function () {
    var newDesc = `<div class='desc-features__block'>
    <div class='desc-features__inner-cont'>
        <div class='desc-feature__item'>
            <svg class='desc-feature__check' width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12.0381C3.6 11.6381 1.16667 14.2048 0 15.5381C0 19.5381 2 22.0381 4 25.5381C6 22.0381 19.5 7.03813 26.5 0.038131C20.5 -0.961853 5.5 18.0381 5 18.0381C4.5 18.0381 4.5 12.5381 4 12.0381Z" fill="#EFA799"/>
</svg>
            <p class='desc_feature__content'>
                Instant Tummy Control & Shaping
            </p>
        </div>
        <div class='desc-feature__item'>
            <svg class='desc-feature__check' width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12.0381C3.6 11.6381 1.16667 14.2048 0 15.5381C0 19.5381 2 22.0381 4 25.5381C6 22.0381 19.5 7.03813 26.5 0.038131C20.5 -0.961853 5.5 18.0381 5 18.0381C4.5 18.0381 4.5 12.5381 4 12.0381Z" fill="#EFA799"/>
</svg>
            <p class='desc_feature__content'>
                Doesn’t Roll Down: Actually Stays Up
            </p>
        </div>
        <div class='desc-feature__item'>
            <svg class='desc-feature__check' width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12.0381C3.6 11.6381 1.16667 14.2048 0 15.5381C0 19.5381 2 22.0381 4 25.5381C6 22.0381 19.5 7.03813 26.5 0.038131C20.5 -0.961853 5.5 18.0381 5 18.0381C4.5 18.0381 4.5 12.5381 4 12.0381Z" fill="#EFA799"/>
</svg>
            <p class='desc_feature__content'>
                Comfortable & Breathable (You can wear it all day)
            </p>
        </div>
        <div class='desc-feature__item'>
            <svg class='desc-feature__check' width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12.0381C3.6 11.6381 1.16667 14.2048 0 15.5381C0 19.5381 2 22.0381 4 25.5381C6 22.0381 19.5 7.03813 26.5 0.038131C20.5 -0.961853 5.5 18.0381 5 18.0381C4.5 18.0381 4.5 12.5381 4 12.0381Z" fill="#EFA799"/>
</svg>
            <p class='desc_feature__content'>
                No Bulding or Spillage
            </p>
        </div>
        <div class='desc-feature__item'>
            <svg class='desc-feature__check' width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12.0381C3.6 11.6381 1.16667 14.2048 0 15.5381C0 19.5381 2 22.0381 4 25.5381C6 22.0381 19.5 7.03813 26.5 0.038131C20.5 -0.961853 5.5 18.0381 5 18.0381C4.5 18.0381 4.5 12.5381 4 12.0381Z" fill="#EFA799"/>
</svg>
            <p class='desc_feature__content'>
                Invisible Under Clothing
            </p>
        </div>
        <div class='desc-feature__item'>
            <svg class='desc-feature__check' width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 12.0381C3.6 11.6381 1.16667 14.2048 0 15.5381C0 19.5381 2 22.0381 4 25.5381C6 22.0381 19.5 7.03813 26.5 0.038131C20.5 -0.961853 5.5 18.0381 5 18.0381C4.5 18.0381 4.5 12.5381 4 12.0381Z" fill="#EFA799"/>
</svg>
            <p class='desc_feature__content'>
                Fits True to Size
            </p>
        </div>
    </div>
</div>`;

var target = document.querySelector('.custom-button-quantity');
if (target && newDesc) {
  target.insertAdjacentHTML('afterend', newDesc);
}

var newUsp = `<div class='usp-features__block'>
    <div class='usp-features__inner-cont'>
        <div class='usp-feature__item'>
            <svg class='usp-feature__icon' width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.8333 25.8333C13.3796 27.091 21.8333 28.8518 29.1666 25.8333" stroke="#E91C7B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.9999 22.8433C20.9204 22.8433 21.6666 22.0971 21.6666 21.1766C21.6666 20.2562 20.9204 19.51 19.9999 19.51C19.0794 19.51 18.3333 20.2562 18.3333 21.1766C18.3333 22.0971 19.0794 22.8433 19.9999 22.8433Z" fill="#E91C7B"/>
<path d="M8.33333 4.16666C9.87983 6.89829 12.4758 12.7146 12.5 18.3333C12.5074 20.0538 12.2345 21.7558 11.6663 23.3451C10.1513 27.5822 7.87875 30.0352 7.5 35.8333" stroke="#E91C7B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M31.6666 4.16666C30.1201 6.89829 27.5241 12.7146 27.4999 18.3333C27.4925 20.0538 27.7654 21.7558 28.3337 23.3451C29.8487 27.5822 32.1212 30.0352 32.4999 35.8333" stroke="#E91C7B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.66663 15C6.66663 15 7.49996 16.6667 7.49996 18.3333C7.49996 19.6752 6.66663 21.6667 6.66663 21.6667" stroke="#E91C7B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M33.3333 15C33.3333 15 32.5 16.6667 32.5 18.3333C32.5 19.6752 33.3333 21.6667 33.3333 21.6667" stroke="#E91C7B" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
            <p class='usp-feature__content'>
                100% Perfect Fit Guarantee
                <svg class='usp-feature__content-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00004 11.3333C8.18893 11.3333 8.34737 11.2693 8.47538 11.1413C8.60337 11.0133 8.66715 10.8551 8.66671 10.6666V7.99998C8.66671 7.81109 8.60271 7.65287 8.47471 7.52531C8.34671 7.39776 8.18849 7.33376 8.00004 7.33331C7.8116 7.33287 7.65338 7.39687 7.52537 7.52531C7.39738 7.65376 7.33337 7.81198 7.33337 7.99998V10.6666C7.33337 10.8555 7.39738 11.014 7.52537 11.142C7.65338 11.27 7.8116 11.3338 8.00004 11.3333ZM8.00004 5.99998C8.18893 5.99998 8.34737 5.93598 8.47538 5.80798C8.60337 5.67998 8.66715 5.52176 8.66671 5.33331C8.66626 5.14487 8.60226 4.98665 8.47471 4.85865C8.34715 4.73065 8.18893 4.66665 8.00004 4.66665C7.81115 4.66665 7.65293 4.73065 7.52537 4.85865C7.39782 4.98665 7.33382 5.14487 7.33337 5.33331C7.33293 5.52176 7.39693 5.6802 7.52537 5.80865C7.65382 5.93709 7.81204 6.00087 8.00004 5.99998ZM8.00004 14.6666C7.07782 14.6666 6.21115 14.4915 5.40004 14.1413C4.58893 13.7911 3.88337 13.3162 3.28338 12.7166C2.68338 12.1171 2.20849 11.4115 1.85871 10.6C1.50893 9.78842 1.33382 8.92176 1.33337 7.99998C1.33293 7.0782 1.50804 6.21153 1.85871 5.39998C2.20937 4.58842 2.68426 3.88287 3.28338 3.28331C3.88249 2.68376 4.58804 2.20887 5.40004 1.85865C6.21204 1.50842 7.07871 1.33331 8.00004 1.33331C8.92137 1.33331 9.78804 1.50842 10.6 1.85865C11.412 2.20887 12.1176 2.68376 12.7167 3.28331C13.3158 3.88287 13.7909 4.58842 14.142 5.39998C14.4932 6.21153 14.668 7.0782 14.6667 7.99998C14.6654 8.92176 14.4903 9.78842 14.1414 10.6C13.7925 11.4115 13.3176 12.1171 12.7167 12.7166C12.1158 13.3162 11.4103 13.7913 10.6 14.142C9.78982 14.4926 8.92315 14.6675 8.00004 14.6666Z" fill="#1C91FF"/>
</svg>
            </p>
        </div>
        <div class='usp-feature__item'>
            <svg class='usp-feature__icon' width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 18.3333C10 17.8913 10.1756 17.4674 10.4882 17.1548C10.8008 16.8423 11.2247 16.6667 11.6667 16.6667C12.1087 16.6667 12.5327 16.8423 12.8452 17.1548C13.1578 17.4674 13.3334 17.8913 13.3334 18.3333C13.3334 18.7754 13.1578 19.1993 12.8452 19.5119C12.5327 19.8244 12.1087 20 11.6667 20C11.2247 20 10.8008 19.8244 10.4882 19.5119C10.1756 19.1993 10 18.7754 10 18.3333ZM11.6667 23.3333C11.2247 23.3333 10.8008 23.5089 10.4882 23.8215C10.1756 24.1341 10 24.558 10 25C10 25.442 10.1756 25.866 10.4882 26.1785C10.8008 26.4911 11.2247 26.6667 11.6667 26.6667C12.1087 26.6667 12.5327 26.4911 12.8452 26.1785C13.1578 25.866 13.3334 25.442 13.3334 25C13.3334 24.558 13.1578 24.1341 12.8452 23.8215C12.5327 23.5089 12.1087 23.3333 11.6667 23.3333ZM16.6667 18.3333C16.6667 17.8913 16.8423 17.4674 17.1549 17.1548C17.4674 16.8423 17.8913 16.6667 18.3334 16.6667C18.7754 16.6667 19.1993 16.8423 19.5119 17.1548C19.8244 17.4674 20 17.8913 20 18.3333C20 18.7754 19.8244 19.1993 19.5119 19.5119C19.1993 19.8244 18.7754 20 18.3334 20C17.8913 20 17.4674 19.8244 17.1549 19.5119C16.8423 19.1993 16.6667 18.7754 16.6667 18.3333ZM18.3334 23.3333C17.8913 23.3333 17.4674 23.5089 17.1549 23.8215C16.8423 24.1341 16.6667 24.558 16.6667 25C16.6667 25.442 16.8423 25.866 17.1549 26.1785C17.4674 26.4911 17.8913 26.6667 18.3334 26.6667C18.7754 26.6667 19.1993 26.4911 19.5119 26.1785C19.8244 25.866 20 25.442 20 25C20 24.558 19.8244 24.1341 19.5119 23.8215C19.1993 23.5089 18.7754 23.3333 18.3334 23.3333ZM23.3334 18.3333C23.3334 17.8913 23.509 17.4674 23.8215 17.1548C24.1341 16.8423 24.558 16.6667 25 16.6667C25.4421 16.6667 25.866 16.8423 26.1786 17.1548C26.4911 17.4674 26.6667 17.8913 26.6667 18.3333C26.6667 18.7754 26.4911 19.1993 26.1786 19.5119C25.866 19.8244 25.4421 20 25 20C24.558 20 24.1341 19.8244 23.8215 19.5119C23.509 19.1993 23.3334 18.7754 23.3334 18.3333ZM3.33337 11.6667C3.33337 9.45654 4.21135 7.33692 5.77415 5.77412C7.33695 4.21132 9.45657 3.33334 11.6667 3.33334H28.3334C30.5435 3.33334 32.6631 4.21132 34.2259 5.77412C35.7887 7.33692 36.6667 9.45654 36.6667 11.6667V28.3333C36.6667 30.5435 35.7887 32.6631 34.2259 34.2259C32.6631 35.7887 30.5435 36.6667 28.3334 36.6667H11.6667C9.45657 36.6667 7.33695 35.7887 5.77415 34.2259C4.21135 32.6631 3.33337 30.5435 3.33337 28.3333V11.6667ZM11.6667 6.66668C10.6323 6.66613 9.62316 6.98644 8.7784 7.58344C7.93365 8.18044 7.29485 9.02475 6.95004 10H33.05C32.7052 9.02475 32.0664 8.18044 31.2217 7.58344C30.3769 6.98644 29.3678 6.66613 28.3334 6.66668H11.6667ZM33.3334 13.3333H6.66671V28.3333C6.66671 29.6594 7.19349 30.9312 8.13117 31.8689C9.06886 32.8066 10.3406 33.3333 11.6667 33.3333H28.3334C29.6595 33.3333 30.9312 32.8066 31.8689 31.8689C32.8066 30.9312 33.3334 29.6594 33.3334 28.3333V13.3333Z" fill="#E91C7B"/>
</svg>
            <p class='usp-feature__content'>
                30-Day FREE US Exchanges
                <svg class='usp-feature__content-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00004 11.3333C8.18893 11.3333 8.34737 11.2693 8.47538 11.1413C8.60337 11.0133 8.66715 10.8551 8.66671 10.6666V7.99998C8.66671 7.81109 8.60271 7.65287 8.47471 7.52531C8.34671 7.39776 8.18849 7.33376 8.00004 7.33331C7.8116 7.33287 7.65338 7.39687 7.52537 7.52531C7.39738 7.65376 7.33337 7.81198 7.33337 7.99998V10.6666C7.33337 10.8555 7.39738 11.014 7.52537 11.142C7.65338 11.27 7.8116 11.3338 8.00004 11.3333ZM8.00004 5.99998C8.18893 5.99998 8.34737 5.93598 8.47538 5.80798C8.60337 5.67998 8.66715 5.52176 8.66671 5.33331C8.66626 5.14487 8.60226 4.98665 8.47471 4.85865C8.34715 4.73065 8.18893 4.66665 8.00004 4.66665C7.81115 4.66665 7.65293 4.73065 7.52537 4.85865C7.39782 4.98665 7.33382 5.14487 7.33337 5.33331C7.33293 5.52176 7.39693 5.6802 7.52537 5.80865C7.65382 5.93709 7.81204 6.00087 8.00004 5.99998ZM8.00004 14.6666C7.07782 14.6666 6.21115 14.4915 5.40004 14.1413C4.58893 13.7911 3.88337 13.3162 3.28338 12.7166C2.68338 12.1171 2.20849 11.4115 1.85871 10.6C1.50893 9.78842 1.33382 8.92176 1.33337 7.99998C1.33293 7.0782 1.50804 6.21153 1.85871 5.39998C2.20937 4.58842 2.68426 3.88287 3.28338 3.28331C3.88249 2.68376 4.58804 2.20887 5.40004 1.85865C6.21204 1.50842 7.07871 1.33331 8.00004 1.33331C8.92137 1.33331 9.78804 1.50842 10.6 1.85865C11.412 2.20887 12.1176 2.68376 12.7167 3.28331C13.3158 3.88287 13.7909 4.58842 14.142 5.39998C14.4932 6.21153 14.668 7.0782 14.6667 7.99998C14.6654 8.92176 14.4903 9.78842 14.1414 10.6C13.7925 11.4115 13.3176 12.1171 12.7167 12.7166C12.1158 13.3162 11.4103 13.7913 10.6 14.142C9.78982 14.4926 8.92315 14.6675 8.00004 14.6666Z" fill="#1C91FF"/>
</svg>
            </p>
        </div>
        <div class='usp-feature__item'>
            <svg class='usp-feature__icon' width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4_82)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18.2142 14.8314V0.717152C15.4599 0.762866 13.2857 0.931437 10.7771 1.15144C9.92519 1.23331 9.11098 1.54281 8.4198 2.0475C7.72862 2.55218 7.1859 3.23349 6.84852 4.02001C6.38566 5.07715 5.85995 6.14287 5.30566 7.26858L5.27709 7.32858C4.20852 9.50001 3.03709 11.8714 2.2628 14.4572C1.99684 14.9321 1.81784 15.4507 1.73423 15.9886L1.58852 16.9086C1.17138 19.5 0.714233 22.3429 0.714233 25.2629C0.714233 28.18 1.17138 31.0257 1.58852 33.6114L1.73423 34.5314C2.07423 36.6743 3.84852 38.3114 6.01995 38.4743L8.49995 38.6743C12.1628 38.9714 16.0428 39.2857 19.9999 39.2857C23.9571 39.2857 27.8371 38.9714 31.4971 38.6743L33.9828 38.4743C35.0359 38.3939 36.0312 37.9611 36.8082 37.2458C37.5852 36.5304 38.0986 35.5743 38.2657 34.5314L38.4114 33.6114C38.8285 31.0257 39.2857 28.1829 39.2857 25.2629C39.2857 22.3429 38.8285 19.5 38.4114 16.9114L38.2657 15.9914C38.1803 15.4448 37.9963 14.9181 37.7228 14.4372C36.9314 11.9914 35.8828 9.88287 34.9228 7.95144L34.8999 7.90858C34.2691 6.67975 33.683 5.42845 33.1428 4.15715C32.8146 3.33805 32.2682 2.62454 31.5631 2.09413C30.8579 1.56372 30.0208 1.2367 29.1428 1.14858C26.6966 0.913467 24.2425 0.768607 21.7857 0.714294V14.8314C24.9628 14.9057 28.0742 15.1572 31.1542 15.4057C32.0076 15.4762 32.859 15.5438 33.7085 15.6086C33.9608 15.6277 34.1994 15.731 34.386 15.902C34.5725 16.073 34.6962 16.3017 34.7371 16.5514L34.8857 17.4714C35.3057 20.0914 35.7142 22.6486 35.7142 25.2629C35.7142 27.8772 35.3057 30.4314 34.8857 33.0514L34.7371 33.9743C34.6962 34.224 34.5725 34.4527 34.386 34.6237C34.1994 34.7947 33.9608 34.8981 33.7085 34.9172L31.1542 35.1172C27.4999 35.4143 23.7999 35.7143 19.9999 35.7143C16.1999 35.7143 12.4999 35.4143 8.84566 35.1172C7.99042 35.0467 7.139 34.98 6.29138 34.9172C6.03905 34.8981 5.80046 34.7947 5.61392 34.6237C5.42738 34.4527 5.30372 34.224 5.2628 33.9743L5.11423 33.0514C4.69423 30.4314 4.28566 27.8772 4.28566 25.2629C4.28566 22.6486 4.69423 20.0914 5.11423 17.4714L5.2628 16.5486C5.3043 16.2994 5.42822 16.0713 5.6147 15.9009C5.80118 15.7305 6.03946 15.6275 6.29138 15.6086L8.84566 15.4086C11.9257 15.1572 15.0371 14.9057 18.2142 14.8314ZM22.5942 30.0029C22.5942 29.4345 22.82 28.8895 23.2219 28.4876C23.6237 28.0858 24.1688 27.86 24.7371 27.86H29.7371C30.3054 27.86 30.8505 28.0858 31.2523 28.4876C31.6542 28.8895 31.8799 29.4345 31.8799 30.0029C31.8799 30.5712 31.6542 31.1162 31.2523 31.5181C30.8505 31.92 30.3054 32.1457 29.7371 32.1457H24.7371C24.1688 32.1457 23.6237 31.92 23.2219 31.5181C22.82 31.1162 22.5942 30.5712 22.5942 30.0029Z" fill="#E91C7B"/>
</g>
<defs>
<clipPath id="clip0_4_82">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>
            <p class='usp-feature__content'>
                FREE US Shipping Orders over $60
                <svg class='usp-feature__content-icon' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.00004 11.3333C8.18893 11.3333 8.34737 11.2693 8.47538 11.1413C8.60337 11.0133 8.66715 10.8551 8.66671 10.6666V7.99998C8.66671 7.81109 8.60271 7.65287 8.47471 7.52531C8.34671 7.39776 8.18849 7.33376 8.00004 7.33331C7.8116 7.33287 7.65338 7.39687 7.52537 7.52531C7.39738 7.65376 7.33337 7.81198 7.33337 7.99998V10.6666C7.33337 10.8555 7.39738 11.014 7.52537 11.142C7.65338 11.27 7.8116 11.3338 8.00004 11.3333ZM8.00004 5.99998C8.18893 5.99998 8.34737 5.93598 8.47538 5.80798C8.60337 5.67998 8.66715 5.52176 8.66671 5.33331C8.66626 5.14487 8.60226 4.98665 8.47471 4.85865C8.34715 4.73065 8.18893 4.66665 8.00004 4.66665C7.81115 4.66665 7.65293 4.73065 7.52537 4.85865C7.39782 4.98665 7.33382 5.14487 7.33337 5.33331C7.33293 5.52176 7.39693 5.6802 7.52537 5.80865C7.65382 5.93709 7.81204 6.00087 8.00004 5.99998ZM8.00004 14.6666C7.07782 14.6666 6.21115 14.4915 5.40004 14.1413C4.58893 13.7911 3.88337 13.3162 3.28338 12.7166C2.68338 12.1171 2.20849 11.4115 1.85871 10.6C1.50893 9.78842 1.33382 8.92176 1.33337 7.99998C1.33293 7.0782 1.50804 6.21153 1.85871 5.39998C2.20937 4.58842 2.68426 3.88287 3.28338 3.28331C3.88249 2.68376 4.58804 2.20887 5.40004 1.85865C6.21204 1.50842 7.07871 1.33331 8.00004 1.33331C8.92137 1.33331 9.78804 1.50842 10.6 1.85865C11.412 2.20887 12.1176 2.68376 12.7167 3.28331C13.3158 3.88287 13.7909 4.58842 14.142 5.39998C14.4932 6.21153 14.668 7.0782 14.6667 7.99998C14.6654 8.92176 14.4903 9.78842 14.1414 10.6C13.7925 11.4115 13.3176 12.1171 12.7167 12.7166C12.1158 13.3162 11.4103 13.7913 10.6 14.142C9.78982 14.4926 8.92315 14.6675 8.00004 14.6666Z" fill="#1C91FF"/>
</svg>
            </p>
        </div>
    </div>
</div>`;

var target = document.querySelector('.desc-features__block');
if (target && newUsp) {
  target.insertAdjacentHTML('afterend', newUsp);
}

var legend = document.querySelector('legend.radio__legend[aria-label="Size"]');
var link = document.querySelector('a.product__info__link[href="/pages/tummy-control-thong-size-chart"]');

if (legend && link) {
  legend.appendChild(link);
}

var ur = window.location.href;

if (ur.includes('/product')) {
  document.addEventListener('DOMContentLoaded', function () {
    var btnClass = ".product__submit__buttons .btn--primary.btn--outline.btn--add-to-cart";
    var prodTitle = ".product__align-left .product__title";
    var prodPrice = "div.product p.price";

    Element.prototype.appendAfterThis = function (element) {
      element.parentNode.insertBefore(this, element.nextSibling);
    };

    var sticky = document.createElement('div');
    sticky.innerHTML = `
      <div class="simple-st-container" id="simple-st-containerID">
        <div class="simple-st-container__outer">
          <div class="simple-product-cont">
            <div class="simple-product-name">
              <p></p>
              <div class="st-reviews"></div>
            </div>
            <div class="simple-product-price"></div>
          </div>
          <div class="simple-st-container__inner">
            <div class="simple-st-item_column__button">
              <a class="simple-st-item__button" rel="nofollow">Add to Cart</a>
            </div>
          </div>
        </div>
      </div>
    `;

    if (!document.querySelector('.simple-st-container')) {
      document.body.appendChild(sticky);

      // Set product title
      var productTitle = document.querySelector(prodTitle);
      var stickyTitle = document.querySelector('.simple-product-name p');
      if (productTitle && stickyTitle) {
        stickyTitle.innerHTML = productTitle.innerHTML;
      }

      setTimeout(function () {
        var priceEl = document.querySelector(prodPrice);
        var stickyPrice = document.querySelector('.simple-product-price');
        if (priceEl && stickyPrice) {
          stickyPrice.innerHTML = priceEl.innerHTML;
        }
      }, 1000);

      var stickyBtn = document.querySelector('.simple-st-item__button');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var scrollTarget = document.querySelector('.product__align-left .product__title');
          if (scrollTarget) {
            scrollTarget.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    }

    function slideShow() {
      document.body.classList.add('simple-sticky');
    }

    function slideHide() {
      document.body.classList.remove('simple-sticky');
    }

    document.addEventListener('scroll', function () {
      var scrollY = window.scrollY;
      var btn = document.querySelector(btnClass);
      if (btn) {
        var triggerPoint = btn.getBoundingClientRect().top + window.scrollY;
        if (scrollY > triggerPoint) {
          slideShow();
        } else {
          slideHide();
        }
      }
    });
  });
}

const formSelectors = document.querySelector('.form__selectors');
const relatedStyles = document.querySelector('.product_related_styles');

if (formSelectors && relatedStyles) {
  formSelectors.append(relatedStyles);
}

const customQuantityBtn = document.querySelector('.custom-button-quantity');
const productQuantityBlock = document.querySelector('.product__block__quantity');

if (customQuantityBtn && productQuantityBlock) {
  customQuantityBtn.prepend(productQuantityBlock);
}

if (document.querySelector('body:has(button.btn--outline.btn--full.btn--primary.btn--add-to-cart[disabled])')) {
  const stickyBtn = document.querySelector('.product-section button.submit_product_btn_sticky');
  if (stickyBtn) {
    stickyBtn.innerHTML = 'SOLD OUT';
  }
}

  console.log('test popup')
    const popupHTMLfit = `
      <div id="fit-popup" class="popup-overlay">
        <div class="popup-content">
          <button class="popup-close" id="close-popup-fit">&times;</button>
          <div class="rte">
            <p>INCHES</p>
            <p><img src="https://cdn.shopify.com/s/files/1/0270/4051/4131/files/Screen_Shot_2022-02-24_at_11.40.48_AM_480x480.png?v=1645720867" alt=""></p>
            <p>CM</p>
            <p><img src="https://cdn.shopify.com/s/files/1/0270/4051/4131/files/Screen_Shot_2022-02-24_at_11.40.53_AM_480x480.png?v=1645720884" alt=""></p>          
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', popupHTMLfit);

    setTimeout(() => {
      const trigger = document.querySelector(".usp-feature__item:first-child svg.usp-feature__content-icon");
      const popup = document.getElementById("fit-popup");
      const closeBtn = document.getElementById("close-popup-fit");

      if (trigger) {
        trigger.addEventListener("click", function () {
          popup.style.display = "block";
          document.body.style.overflow = "hidden";
        });
      }

      closeBtn?.addEventListener("click", function () {
        popup.style.display = "none";
        document.body.style.overflow = "";
      });

      popup?.addEventListener("click", function (e) {
        if (e.target === popup) {
          popup.style.display = "none";
          document.body.style.overflow = "";
        }
      });
    }, 500);

    console.log('test popup')
    const popupHTMLrefund = `
      <div id="refund-popup" class="popup-overlay">
        <div class="popup-content">
          <button class="popup-close" id="close-popup-refund">&times;</button>
          <div class="rte">
              <p><span><strong>Refunds Policy</strong></span></p>
              <p><span><strong>All items are final sale. They can either be exchanged for free or compensated with store credit with an equal value of the product you purchased.</strong></span></p>
              <p>Damaged or lost items can either be replaced by us free of charge or refunded to the original payment method used.<br></p>
              <p><span></span><span>If your damage request is approved, then your refund will be processed, and a credit will automatically be applied to your original method of payment, within 5-7 business days.</span></p>
              <p><span>There are certain situations where only partial refunds are granted (if applicable)</span></p>
              <p><span><strong>Late or missing refunds (if applicable)</strong></span></p>
              <p><span>If you haven’t received a refund yet, first check your bank account again.</span></p>
              <p><span>Then contact your credit card company, it may take some time before your refund is officially posted.</span></p>
              <p><span>If you’ve done all of this and you still have not received your refund yet, please contact us at&nbsp;<strong>help@peachyshapewear.com</strong></span></p>
              <p><strong>All orders receive a free exchange or store credit with every purchase</strong></p>
              <p><span>Any items in new condition,&nbsp;and with all tags attached can be exchanged for free or be provided with a store credit within 30 days after we receive your order. We do not accept exchanges or give store credit after that time has passed.</span></p>
              <p><span><strong>Exchanges (if applicable)</strong></span></p>
              <p><span>We only replace items if they do not fit, are defective, or are damaged upon arrival. If you need to exchange it for the same item, send us an email at&nbsp;&nbsp;<strong>help@peachyshapewear.com</strong></span></p>
              <p><strong>Store Credit</strong></p>
              <p>Store credit with a value equal to the product will be offered if an exchange is not needed. Once your order is inspected, we will send you a E-GIFT CARD CODE that will contain the dollar value of your item.<strong></strong><br><br>If you are unsatisfied with your order - please contact our support and we will do our best to help you out!</p>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', popupHTMLrefund);

    setTimeout(() => {
      const trigger = document.querySelector(".usp-feature__item:nth-child(2) svg.usp-feature__content-icon");
      const popup = document.getElementById("refund-popup");
      const closeBtn = document.getElementById("close-popup-refund");

      if (trigger) {
        trigger.addEventListener("click", function () {
          popup.style.display = "block";
          document.body.style.overflow = "hidden";
        });
      }

      closeBtn?.addEventListener("click", function () {
        popup.style.display = "none";
        document.body.style.overflow = "";
      });

      popup?.addEventListener("click", function (e) {
        if (e.target === popup) {
          popup.style.display = "none";
          document.body.style.overflow = "";
        }
      });
    }, 500);

    console.log('test popup')
    const popupHTMLshipping = `
      <div id="shipping-popup" class="popup-overlay">
        <div class="popup-content">
          <button class="popup-close" id="close-popup-shipping">&times;</button>
          <div class="rte">
            <h3>Shipping Policy</h3>
            <p><strong><em>Order processing times are separate from the shipping times you see at checkout.&nbsp;</em></strong></p>
            <p><strong>All orders receive free exchanges if applicable</strong></p>
            <p>All orders are processed within <strong>2 to 5 business days (excluding weekends and holidays)</strong> after receiving your order confirmation email. You will receive another notification when your order has shipped. All orders received after 6:00PM Est will be processed the next business day.<br></p>
            <h3>Domestic Shipping Rates and Estimates</h3>
            <div class="rte__table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Shipping option</th>
                    <th>Estimated delivery time</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Standard Shipping<br>(Free over $60)</td>
                    <td>5 - 10 Business Days</td>
                    <td>$7.95</td>
                  </tr>
                  <tr>
                    <td>Express FedEx 2 Day</td>
                    <td>2-5 Business Days</td>
                    <td>$19.95</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h3>International Shipping</h3>
            <p>We offer international shipping to most countries through a new service called Passport Shipping Program. Passport Shipping is a shipping carrier that helps direct-to-consumer brands ship their products internationally. With Passport Shipping, the products are delivered to our customers quickly straight to their doorstep. All duties and taxes are paid at the time of purchase so it saves time and money.&nbsp;</p>
            <div class="rte__table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Shipping option</th>
                    <th>Estimated delivery time</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Standard Shipping</td>
                    <td>10-14 days</td>
                    <td>Varies by weight</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p>Contact help@passportshipping.com if you have any questions regarding international shipping.&nbsp;</p>
            <h3>How do I check the status of my order?</h3>
            <p>When your order has shipped, you will receive an email notification from us which will include a tracking number you can use to check its status. Please allow 48 hours for the tracking information to become available.&nbsp;</p>
            <p>If you haven’t received your order within 21 days of receiving your shipping confirmation email, please contact us at help@peachyshapewear.com with your name and order number, and we will look into it for you.</p>
            <p>Tracking&nbsp;numbers are sent&nbsp;out to the email that was provided during the order as soon as the order is processed and shipped.</p>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', popupHTMLshipping);

    setTimeout(() => {
      const trigger = document.querySelector(".usp-feature__item:last-child svg.usp-feature__content-icon");
      const popup = document.getElementById("shipping-popup");
      const closeBtn = document.getElementById("close-popup-shipping");

      if (trigger) {
        trigger.addEventListener("click", function () {
          popup.style.display = "block";
          document.body.style.overflow = "hidden";
        });
      }

      closeBtn?.addEventListener("click", function () {
        popup.style.display = "none";
        document.body.style.overflow = "";
      });

      popup?.addEventListener("click", function (e) {
        if (e.target === popup) {
          popup.style.display = "none";
          document.body.style.overflow = "";
        }
      });
    }, 500);

    document.querySelectorAll(".product-section .sticky-btn_add_item").forEach(function(el) {
      el.remove();
    });
});